import React from 'react'
import PropTypes from 'prop-types'
import { themes } from 'contexts/theme-context'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-basis: row nowrap;
  padding: 12px 24px;
  background: #fff;
  border-bottom: 1px solid #e2e2e2;
  position: relative;
`

const IconWrapper = styled.div`
  svg {
    width: 40px;
  }
`

const ThemeWrapper = styled.div`
  padding: 0 0 0 12px;
  font-size: 12px;
  line-height: 18px;

  h4 {
    color: #384047;
    margin: 0;
    font-weight: 700;
    font-size: 14px;
  }

  p {
    margin: 8px 0 0;
    color: #afb2b7;
    font-weight: 300;
  }
`

function AccordionTrigger(props) {
  const { themeName } = props
  const theme = themes[themeName]

  return (
    <Wrapper>
      <IconWrapper>
        <a
          href={theme.siteUrl}
          onClick={(event) => {
            event.stopPropagation()
          }}
        >
          {theme.shield}
        </a>
      </IconWrapper>
      <ThemeWrapper>
        <h4>{theme.displayName}</h4>
        <p>{theme.description}</p>
      </ThemeWrapper>
    </Wrapper>
  )
}

AccordionTrigger.propTypes = {
  themeName: PropTypes.string.isRequired,
}

export default AccordionTrigger



// WEBPACK FOOTER //
// ./src/organisms/Header/MobileHeader/components/AccordionTrigger.js